//フローティングバナー
const intersectionContainer = document.querySelector(".js-body-inner");
const intersectionTarget = document.querySelector(".js-header");
const intersectionTarget2 = document.querySelector(".js-fv");
const infiniteScrollObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      console.log(entry.intersectionRatio * 100);
      if (!entry.isIntersecting) {
        intersectionTarget.classList.remove("is-shown");
        intersectionTarget2.classList.remove("is-shown");

      } else {
        intersectionTarget.classList.add("is-shown");
        intersectionTarget2.classList.add("is-shown");
      }
    });
  },
  {
    threshold: buildThresholdList(),
  }
);
infiniteScrollObserver.observe(intersectionContainer);
function buildThresholdList() {
  let numSteps = 90;
  let thresholds = [];

  for (let i = 1; i <= numSteps; i++) {
    let ratio = i / numSteps;
    thresholds.push(ratio);
  }
  return thresholds;
}